import { container, singleton } from "tsyringe";
import CommentApi from "api/clapaction/projects/[id]/config/forum/posts/[postId]/comments/CommentApi";
import CommentIdApi from "api/clapaction/projects/[id]/config/forum/posts/[postId]/comments/[commentId]/CommentIdApi";
import CommentRequestResource from "common/resources/Project/Config/Forum/Comment/CommentRequestResource";
import CommentResponseResource from "common/resources/Project/Config/Forum/Comment/CommentResponseResource";
import toValidationError from "utils/toValidationError";

@singleton()
export default class CommentService {
	private commentApi: CommentApi = container.resolve(CommentApi);
	private commentIdApi: CommentIdApi = container.resolve(CommentIdApi);

	/**
	 * @description Get all comments for a post
	 */
	public async getAll(projectId: string, postId: string): Promise<CommentResponseResource[]> {
		return this.commentApi.getAll(projectId, postId).catch(toValidationError);
	}

	/**
	 * @description Count comments for a post
	 */
	public async count(projectId: string, postId: string): Promise<{ count: number }> {
		return this.commentApi.count(projectId, postId).catch(toValidationError);
	}

	/**
	 * @description Create a comment on a post
	 */
	public async create(projectId: string, postId: string, request: CommentRequestResource): Promise<CommentResponseResource> {
		return this.commentApi.create(projectId, postId, request).catch(toValidationError);
	}

	/**
	 * @description Get a comment by id
	 */
	public async getById(projectId: string, postId: string, commentId: string): Promise<CommentResponseResource> {
		return this.commentIdApi.getById(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Count replies for a comments
	 */
	public async countReplies(projectId: string, postId: string, commentId: string): Promise<{ count: number }> {
		return this.commentIdApi.countReplies(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Reply to a comment
	 */
	public async reply(projectId: string, postId: string, commentId: string, request: CommentRequestResource): Promise<CommentResponseResource> {
		return this.commentIdApi.reply(projectId, postId, commentId, request).catch(toValidationError);
	}

	/**
	 * @description Check if a comment can be deleted by the user
	 */
	public async canDelete(projectId: string, postId: string, commentId: string): Promise<boolean> {
		return this.commentIdApi.canDelete(projectId, postId, commentId).catch(toValidationError);
	}

	/**
	 * @description Delete a comment
	 */
	public async delete(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.commentIdApi.delete(projectId, postId, commentId).catch(toValidationError);
	}
}
